/**
 * Идентификатор диалога для журнала ответов ассистента.
 *
 * Живёт в sessionStorage: вопросы одного посетителя собираются вместе, но между
 * визитами ничего не переносится и в базу не попадает ничего лишнего.
 * Если хранилище недоступно (приватный режим), журнал просто останется без
 * session_id — на ответы пользователя это не влияет.
 */
const STORAGE_KEY = "dev48-assistant-session";

export function assistantSessionId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    const existing = window.sessionStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const created = crypto.randomUUID();
    window.sessionStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return undefined;
  }
}
